import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown,
  Checkbox,
  TextArea
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardSystemicEvaluationUX = (props: any) => {
    return(
      <div
        id="CardSystemicEvaluationUX-div-0">
        <div
          id="CardSystemicEvaluationUX-div-156"
          style={{ display: "flex", justifyContent: "flex-end" }}>
          
          <div
            id="CardSystemicEvaluationUX-div-157"
            style={{display: "flex",height:"40px", fontWeight:"bold",alignItems:"center", ...(props.systemicEvaluation?.status !== "DRAFT" && { display: "none" })}}>
            {props.languageUX === "en" ? "Latest recorder:" : "ผู้บันทึกล่าสุด:"}
          </div>
          <div
            id="CardSystemicEvaluationUX-div-158"
            style={{ width: "10%", margin: "0px 10px", ...(props.systemicEvaluation?.status !== "DRAFT" && { display: "none" }) }}>
            {props.systemicEvaluation?.edit_user_name || ""}
          </div>
          <div
            id="CardSystemicEvaluationUX-div-159"
            style={{ width: "10%", margin: "0px 10px", ...(props.systemicEvaluation?.status !== "DRAFT" && { display: "none" }) }}>
            {props.systemicEvaluation?.edited || ""}
          </div>
          <div
            id="CardSystemicEvaluationUX-div-160">
            {props.buttonSave}
          </div>
        </div>
        <Form
          id="CardSystemicEvaluationUX-Form-1">
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-3"
            inline={true}
            style={{ display: "flex", alignItems: "center" }}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-15"
              inline={true}
              width={2}>
              <div
                id="CardSystemicEvaluationUX-div-48"
                style={{ fontWeight: "bold" }}>
                {props.languageUX === "en" ? "Systemic Evaluation" : "การประเมินระบบต่าง ๆ ของร่างกาย"}
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-16"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-47"
                style={{ width: "80%" }}>
                
                <Dropdown
                  fluid={true}
                  id="CardSystemicEvaluationUX-Dropdown-49"
                  name="systemicEvaluationType"
                  onChange={props.handleChangeData}
                  options={props.systemicEvaluationOptions}
                  selection={true}
                  value={props.systemicEvaluation?.systemicEvaluationType}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-4"
            inline={true}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-18"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-19"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-50">
                
                <Checkbox
                  checked={props.systemicEvaluation?.respiratoryCheck}
                  disabled={props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  id="CardSystemicEvaluationUX-Checkbox-68"
                  label={props.languageUX === "en" ? "Respiratory" : "ระบบทางเดินหายใจ"}
                  name="respiratoryCheck"
                  onChange={props.handleChangeData}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-20"
              inline={true}
              width={7}>
              <div
                id="CardSystemicEvaluationUX-div-51"
                style={{ width: "100%" }}>
                
                <Dropdown
                  allowAdditions={true}
                  disabled={!props.systemicEvaluation?.respiratoryCheck || props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  fluid={true}
                  id="CardSystemicEvaluationUX-Dropdown-85"
                  multiple={true}
                  name="respiratoryDetail"
                  onAddItem={props.handleAddOptions}
                  onChange={props.handleChangeData}
                  options={props.respiratoryOptions}
                  search={true}
                  selection={true}
                  value={props.systemicEvaluation?.respiratoryDetail}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-5"
            inline={true}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-21"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-22"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-52">
                
                <Checkbox
                  checked={props.systemicEvaluation?.cardiovascularCheck}
                  disabled={props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  id="CardSystemicEvaluationUX-Checkbox-69"
                  label={props.languageUX === "en" ? "Cardiovascular" : "ระบบหัวใจและหลอดเลือด"}
                  name="cardiovascularCheck"
                  onChange={props.handleChangeData}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-23"
              inline={true}
              width={7}>
              <div
                id="CardSystemicEvaluationUX-div-53"
                style={{ width: "100%" }}>
                
                <Dropdown
                  allowAdditions={true}
                  disabled={!props.systemicEvaluation?.cardiovascularCheck || props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  fluid={true}
                  id="CardSystemicEvaluationUX-Dropdown-162"
                  multiple={true}
                  name="cardiovascularDetail"
                  onAddItem={props.handleAddOptions}
                  onChange={props.handleChangeData}
                  options={props.cardiovascularOptions}
                  search={true}
                  selection={true}
                  value={props.systemicEvaluation?.cardiovascularDetail}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-6"
            inline={true}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-24"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-25"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-54">
                
                <Checkbox
                  checked={props.systemicEvaluation?.neurologicCheck}
                  disabled={props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  id="CardSystemicEvaluationUX-Checkbox-70"
                  label={props.languageUX === "en" ? "Neurologic" : "ระบบประสาท"}
                  name="neurologicCheck"
                  onChange={props.handleChangeData}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-26"
              inline={true}
              width={7}>
              <div
                id="CardSystemicEvaluationUX-div-55"
                style={{ width: "100%" }}>
                
                <Dropdown
                  allowAdditions={true}
                  disabled={!props.systemicEvaluation?.neurologicCheck || props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  fluid={true}
                  id="CardSystemicEvaluationUX-Dropdown-163"
                  multiple={true}
                  name="neurologicDetail"
                  onAddItem={props.handleAddOptions}
                  onChange={props.handleChangeData}
                  options={props.neurologicOptions}
                  search={true}
                  selection={true}
                  value={props.systemicEvaluation?.neurologicDetail}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-7"
            inline={true}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-27"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-28"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-56">
                
                <Checkbox
                  checked={props.systemicEvaluation?.eentCheck}
                  disabled={props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  id="CardSystemicEvaluationUX-Checkbox-71"
                  label={props.languageUX === "en" ? "HEENT" : "HEENT"}
                  name="eentCheck"
                  onChange={props.handleChangeData}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-29"
              inline={true}
              width={7}>
              <div
                id="CardSystemicEvaluationUX-div-57"
                style={{ width: "100%" }}>
                
                <Dropdown
                  allowAdditions={true}
                  disabled={!props.systemicEvaluation?.eentCheck || props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  fluid={true}
                  id="CardSystemicEvaluationUX-Dropdown-164"
                  multiple={true}
                  name="eentDetail"
                  onAddItem={props.handleAddOptions}
                  onChange={props.handleChangeData}
                  options={props.eentOptions}
                  search={true}
                  selection={true}
                  value={props.systemicEvaluation?.eentDetail}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-8"
            inline={true}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-30"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-31"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-58">
                
                <Checkbox
                  checked={props.systemicEvaluation?.giCheck}
                  disabled={props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  id="CardSystemicEvaluationUX-Checkbox-72"
                  label={props.languageUX === "en" ? "GI" : "GI"}
                  name="giCheck"
                  onChange={props.handleChangeData}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-32"
              inline={true}
              width={7}>
              <div
                id="CardSystemicEvaluationUX-div-59"
                style={{ width: "100%" }}>
                
                <Dropdown
                  allowAdditions={true}
                  disabled={!props.systemicEvaluation?.giCheck || props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  fluid={true}
                  id="CardSystemicEvaluationUX-Dropdown-165"
                  multiple={true}
                  name="giDetail"
                  onAddItem={props.handleAddOptions}
                  onChange={props.handleChangeData}
                  options={props.giOptions}
                  search={true}
                  selection={true}
                  value={props.systemicEvaluation?.giDetail}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-9"
            inline={true}
            widths={4}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-86"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-35"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-60">
                
                <Checkbox
                  checked={props.systemicEvaluation?.genitourinaryCheck}
                  disabled={props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  id="CardSystemicEvaluationUX-Checkbox-73"
                  label={props.languageUX === "en" ? "Genitourinary" : "ระบบทางเดินปัสสาวะและอวัยวะสืบพันธุ์"}
                  name="genitourinaryCheck"
                  onChange={props.handleChangeData}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-36"
              inline={true}
              width={7}>
              <div
                id="CardSystemicEvaluationUX-div-61"
                style={{ width: "100%" }}>
                
                <Dropdown
                  allowAdditions={true}
                  disabled={!props.systemicEvaluation?.genitourinaryCheck || props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  fluid={true}
                  id="CardSystemicEvaluationUX-Dropdown-166"
                  multiple={true}
                  name="genitourinaryDetail"
                  onAddItem={props.handleAddOptions}
                  onChange={props.handleChangeData}
                  options={props.genitourinaryOptions}
                  search={true}
                  selection={true}
                  value={props.systemicEvaluation?.genitourinaryDetail}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-10"
            inline={true}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-37"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-38"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-62">
                
                <Checkbox
                  checked={props.systemicEvaluation?.endrocrineCheck}
                  disabled={props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  id="CardSystemicEvaluationUX-Checkbox-74"
                  label={props.languageUX === "en" ? "Endocrine & metabolic" : "ระบบต่อมไร้ท่อ และระบบเผาผลาญ"}
                  name="endrocrineCheck"
                  onChange={props.handleChangeData}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-39"
              inline={true}
              width={7}>
              <div
                id="CardSystemicEvaluationUX-div-63"
                style={{ width: "100%" }}>
                
                <Dropdown
                  allowAdditions={true}
                  disabled={!props.systemicEvaluation?.endrocrineCheck || props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  fluid={true}
                  id="CardSystemicEvaluationUX-Dropdown-84"
                  multiple={true}
                  name="endrocrineDetail"
                  onAddItem={props.handleAddOptions}
                  onChange={props.handleChangeData}
                  options={props.endrocrineOptions}
                  search={true}
                  selection={true}
                  value={props.systemicEvaluation?.endrocrineDetail}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-11"
            inline={true}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-40"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-41"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-64">
                
                <Checkbox
                  checked={props.systemicEvaluation?.skinCheck}
                  disabled={props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  id="CardSystemicEvaluationUX-Checkbox-75"
                  label={props.languageUX === "en" ? "Skin /  Breast" : "ผิวหนัง / เต้านม"}
                  name="skinCheck"
                  onChange={props.handleChangeData}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-42"
              inline={true}
              width={7}>
              <div
                id="CardSystemicEvaluationUX-div-65"
                style={{ width: "100%" }}>
                
                <Dropdown
                  allowAdditions={true}
                  disabled={!props.systemicEvaluation?.skinCheck || props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  fluid={true}
                  id="CardSystemicEvaluationUX-Dropdown-167"
                  multiple={true}
                  name="skinDetail"
                  onAddItem={props.handleAddOptions}
                  onChange={props.handleChangeData}
                  options={props.skinOptions}
                  search={true}
                  selection={true}
                  value={props.systemicEvaluation?.skinDetail}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-12"
            inline={true}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-43"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-44"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-66">
                
                <Checkbox
                  checked={props.systemicEvaluation?.immunologyCheck}
                  disabled={props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  id="CardSystemicEvaluationUX-Checkbox-76"
                  label={props.languageUX === "en" ? "Immunology / Hematology" : "ระบบภูมิคุ้มกัน / ระบบเลือด"}
                  name="immunologyCheck"
                  onChange={props.handleChangeData}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-45"
              inline={true}
              width={7}>
              <div
                id="CardSystemicEvaluationUX-div-67"
                style={{ width: "100%" }}>
                
                <Dropdown
                  allowAdditions={true}
                  disabled={!props.systemicEvaluation?.immunologyCheck || props.systemicEvaluation?.systemicEvaluationType !== "Abnormal"}
                  fluid={true}
                  id="CardSystemicEvaluationUX-Dropdown-168"
                  multiple={true}
                  name="immunologyDetail"
                  onAddItem={props.handleAddOptions}
                  onChange={props.handleChangeData}
                  options={props.immunologyOptions}
                  search={true}
                  selection={true}
                  value={props.systemicEvaluation?.immunologyDetail}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-13"
            inline={true}
            style={{ alignItems: "flex-start", margin: "30px 0px" }}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-88"
              inline={true}
              width={2}>
              <div
                id="CardSystemicEvaluationUX-div-92"
                style={{ display: "flex", alignItems: "center", width: "100%" }}>
                
                <div
                  id="CardSystemicEvaluationUX-div-96"
                  style={{ fontWeight: "bold" }}>
                  {props.languageUX === "en" ? "Lab Data:" : "ข้อมูลห้องปฏิบัติการ:"}
                </div>
                <div
                  id="CardSystemicEvaluationUX-div-97"
                  style={{ margin: "0px 10px" }}>
                  {props.logoLab}
                </div>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-90"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-93"
                style={{ width: "80%" }}>
                
                <Dropdown
                  fluid={true}
                  id="CardSystemicEvaluationUX-Dropdown-102"
                  name="labDataType"
                  onChange={props.handleChangeData}
                  options={props.systemicEvaluationOptions}
                  selection={true}
                  value={props.systemicEvaluation?.labDataType}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-99"
              inline={true}
              width={7}>
              <div
                id="CardSystemicEvaluationUX-div-103"
                style={{ width: "100%"  }}>
                
                <TextArea
                  id="CardSystemicEvaluationUX-TextArea-146"
                  name="labDataDetail"
                  onChange={props.handleChangeData}
                  rows={2}
                  style={{ resize: "none" }}
                  value={props.systemicEvaluation?.labDataDetail}>
                </TextArea>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-101"
              inline={true}
              width={4}>
              <div
                id="CardSystemicEvaluationUX-div-105"
                style={{ display: "flex", alignItems: "center", width: "100%" }}>
                
                <div
                  id="CardSystemicEvaluationUX-div-106"
                  style={{ fontWeight: "bold" , width: "30%"}}>
                  {props.languageUX === "en" ? "Result date:" : "วันที่รายงานผล :"}
                </div>
                <div
                  id="CardSystemicEvaluationUX-div-107"
                  style={{ width: "60%" }}>
                  
                  <DateTextBox
                    id="CardSystemicEvaluationUX-DateTextBox-108"
                    onChange={props.handleChangeLabDate}
                    value={props.systemicEvaluation?.labDataDate}>
                  </DateTextBox>
                </div>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-14"
            inline={true}
            style={{ alignItems: "flex-start" }}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-89"
              inline={true}
              width={2}>
              <div
                id="CardSystemicEvaluationUX-div-94"
                style={{ fontWeight: "bold" }}>
                {props.languageUX === "en" ? "Other Investigations :" : "การตรวจเพิ่มเติมที่เกี่ยวข้อง :"}
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-91"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-95">
                
                <Checkbox
                  checked={props.systemicEvaluation?.xRayCheck}
                  id="CardSystemicEvaluationUX-Checkbox-128"
                  label={props.languageUX === "en" ? "Chest X-ray" : "Chest X-ray"}
                  name="xRayCheck"
                  onChange={props.handleChangeData}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-111"
              inline={true}
              width={7}>
              <div
                id="CardSystemicEvaluationUX-div-132"
                style={{ width: "100%" }}>
                
                <TextArea
                  disabled={!props.systemicEvaluation?.xRayCheck}
                  id="CardSystemicEvaluationUX-TextArea-145"
                  name="xRayDetail"
                  onChange={props.handleChangeData}
                  rows={2}
                  style={{ resize: "none" }}
                  value={props.systemicEvaluation?.xRayDetail}>
                </TextArea>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-171"
              inline={true}
              width={4}>
              <div
                id="CardSystemicEvaluationUX-div-174"
                style={{ display: "flex", alignItems: "center", width: "100%" }}>
                
                <div
                  id="CardSystemicEvaluationUX-div-175"
                  style={{ fontWeight: "bold" , width: "30%"}}>
                  {props.languageUX === "en" ? "Result date:" : "วันที่รายงานผล :"}
                </div>
                <div
                  id="CardSystemicEvaluationUX-div-176"
                  style={{ width: "60%" }}>
                  
                  <DateTextBox
                    disabled={!props.systemicEvaluation?.xRayCheck}
                    id="CardSystemicEvaluationUX-DateTextBox-183"
                    onChange={props.handleChangeXRayDate}
                    value={props.systemicEvaluation?.xRayDate}>
                  </DateTextBox>
                </div>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-87"
            inline={true}
            style={{ alignItems: "flex-start" }}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-112"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-113"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-122">
                
                <Checkbox
                  checked={props.systemicEvaluation?.imagingCheck}
                  id="CardSystemicEvaluationUX-Checkbox-129"
                  label={props.languageUX === "en" ? "Imaging" : "Imaging"}
                  name="imagingCheck"
                  onChange={props.handleChangeData}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-114"
              inline={true}
              width={7}>
              <div
                id="CardSystemicEvaluationUX-div-123"
                style={{ width: "100%" }}>
                
                <TextArea
                  disabled={!props.systemicEvaluation?.imagingCheck}
                  id="CardSystemicEvaluationUX-TextArea-144"
                  name="imagingDetail"
                  onChange={props.handleChangeData}
                  rows={2}
                  style={{ resize: "none" }}
                  value={props.systemicEvaluation?.imagingDetail}>
                </TextArea>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-170"
              inline={true}
              width={4}>
              <div
                id="CardSystemicEvaluationUX-div-172"
                style={{ display: "flex", alignItems: "center", width: "100%" }}>
                
                <div
                  id="CardSystemicEvaluationUX-div-177"
                  style={{ fontWeight: "bold" , width: "30%"}}>
                  {props.languageUX === "en" ? "Result date:" : "วันที่รายงานผล :"}
                </div>
                <div
                  id="CardSystemicEvaluationUX-div-178"
                  style={{ width: "60%" }}>
                  
                  <DateTextBox
                    disabled={!props.systemicEvaluation?.imagingCheck}
                    id="CardSystemicEvaluationUX-DateTextBox-182"
                    onChange={props.handleChangeImagingDate}
                    value={props.systemicEvaluation?.imagingDate}>
                  </DateTextBox>
                </div>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-109"
            inline={true}
            style={{ alignItems: "flex-start" }}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-115"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-116"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-125">
                
                <Checkbox
                  checked={props.systemicEvaluation?.ekgCheck}
                  id="CardSystemicEvaluationUX-Checkbox-130"
                  label={props.languageUX === "en" ? "EKG" : "EKG"}
                  name="ekgCheck"
                  onChange={props.handleChangeData}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-117"
              inline={true}
              width={7}>
              <div
                id="CardSystemicEvaluationUX-div-124"
                style={{ width: "100%" }}>
                
                <TextArea
                  disabled={!props.systemicEvaluation?.ekgCheck}
                  id="CardSystemicEvaluationUX-TextArea-143"
                  name="ekgDetail"
                  onChange={props.handleChangeData}
                  rows={2}
                  style={{ resize: "none" }}
                  value={props.systemicEvaluation?.ekgDetail}>
                </TextArea>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-137"
              inline={true}
              width={4}>
              <div
                id="CardSystemicEvaluationUX-div-138"
                style={{ display: "flex", alignItems: "center", width: "100%" }}>
                
                <div
                  id="CardSystemicEvaluationUX-div-139"
                  style={{ fontWeight: "bold" , width: "30%"}}>
                  {props.languageUX === "en" ? "Result date:" : "วันที่รายงานผล :"}
                </div>
                <div
                  id="CardSystemicEvaluationUX-div-140"
                  style={{ width: "60%" }}>
                  
                  <DateTextBox
                    disabled={!props.systemicEvaluation?.ekgCheck}
                    onChange={props.handleChangeEKGDate}
                    value={props.systemicEvaluation?.ekgDate}>
                  </DateTextBox>
                </div>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSystemicEvaluationUX-FormGroup-110"
            inline={true}
            style={{ alignItems: "flex-start" }}>
            <FormField
              id="CardSystemicEvaluationUX-FormField-118"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-119"
              inline={true}
              width={3}>
              <div
                id="CardSystemicEvaluationUX-div-127">
                
                <Checkbox
                  checked={props.systemicEvaluation?.otherCheck}
                  id="CardSystemicEvaluationUX-Checkbox-131"
                  label={props.languageUX === "en" ? "Other" : "อื่นๆ"}
                  name="otherCheck"
                  onChange={props.handleChangeData}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-120"
              inline={true}
              width={7}>
              <div
                id="CardSystemicEvaluationUX-div-126"
                style={{ width: "100%" }}>
                
                <TextArea
                  disabled={!props.systemicEvaluation?.otherCheck}
                  id="CardSystemicEvaluationUX-TextArea-142"
                  name="otherDetail"
                  onChange={props.handleChangeData}
                  rows={2}
                  style={{ resize: "none" }}
                  value={props.systemicEvaluation?.otherDetail}>
                </TextArea>
              </div>
            </FormField>
            <FormField
              id="CardSystemicEvaluationUX-FormField-169"
              inline={true}
              width={4}>
              <div
                id="CardSystemicEvaluationUX-div-173"
                style={{ display: "flex", alignItems: "center", width: "100%" }}>
                
                <div
                  id="CardSystemicEvaluationUX-div-179"
                  style={{ fontWeight: "bold" , width: "30%"}}>
                  {props.languageUX === "en" ? "Result date:" : "วันที่รายงานผล :"}
                </div>
                <div
                  id="CardSystemicEvaluationUX-div-180"
                  style={{ width: "60%" }}>
                  
                  <DateTextBox
                    disabled={!props.systemicEvaluation?.otherCheck}
                    id="CardSystemicEvaluationUX-DateTextBox-181"
                    onChange={props.handleChangeOtherDate}
                    value={props.systemicEvaluation?.otherDate}>
                  </DateTextBox>
                </div>
              </div>
            </FormField>
          </FormGroup>
        </Form>
      </div>
    )
}


export default CardSystemicEvaluationUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Fri Oct 31 2025 04:20:17 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-0"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Form-1"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ alignItems: \"flex-start\", margin: \"30px 0px\" }"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-14"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ alignItems: \"flex-start\" }"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-15"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-18"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-19"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-21"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-22"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-23"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-24"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-25"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-29"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-30"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-32"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-35"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-36"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-37"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-38"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-39"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-40"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-41"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-42"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-43"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-44"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"80%\" }"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "การประเมินระบบต่าง ๆ ของร่างกาย",
          "valueEN": "Systemic Evaluation"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Dropdown",
      "parent": 47,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Dropdown-49"
        },
        "name": {
          "type": "value",
          "value": "systemicEvaluationType"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.systemicEvaluationOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.systemicEvaluationType"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-50"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-52"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-54"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-56"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-58"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-60"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-62"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-63"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-64"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-66"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-67"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "Checkbox",
      "parent": 50,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.systemicEvaluation?.respiratoryCheck"
        },
        "disabled": {
          "type": "code",
          "value": "props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Checkbox-68"
        },
        "label": {
          "type": "value",
          "value": "ระบบทางเดินหายใจ",
          "valueEN": "Respiratory"
        },
        "name": {
          "type": "value",
          "value": "respiratoryCheck"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "onClick": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "Checkbox",
      "parent": 52,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.systemicEvaluation?.cardiovascularCheck"
        },
        "disabled": {
          "type": "code",
          "value": "props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Checkbox-69"
        },
        "label": {
          "type": "value",
          "value": "ระบบหัวใจและหลอดเลือด",
          "valueEN": "Cardiovascular"
        },
        "name": {
          "type": "value",
          "value": "cardiovascularCheck"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "Checkbox",
      "parent": 54,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.systemicEvaluation?.neurologicCheck"
        },
        "disabled": {
          "type": "code",
          "value": "props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Checkbox-70"
        },
        "label": {
          "type": "value",
          "value": "ระบบประสาท",
          "valueEN": "Neurologic"
        },
        "name": {
          "type": "value",
          "value": "neurologicCheck"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "Checkbox",
      "parent": 56,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.systemicEvaluation?.eentCheck"
        },
        "disabled": {
          "type": "code",
          "value": "props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Checkbox-71"
        },
        "label": {
          "type": "value",
          "value": "HEENT",
          "valueEN": "HEENT"
        },
        "name": {
          "type": "value",
          "value": "eentCheck"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "Checkbox",
      "parent": 58,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.systemicEvaluation?.giCheck"
        },
        "disabled": {
          "type": "code",
          "value": "props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Checkbox-72"
        },
        "label": {
          "type": "value",
          "value": "GI",
          "valueEN": "GI"
        },
        "name": {
          "type": "value",
          "value": "giCheck"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "Checkbox",
      "parent": 60,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.systemicEvaluation?.genitourinaryCheck"
        },
        "disabled": {
          "type": "code",
          "value": "props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Checkbox-73"
        },
        "label": {
          "type": "value",
          "value": "ระบบทางเดินปัสสาวะและอวัยวะสืบพันธุ์",
          "valueEN": "Genitourinary"
        },
        "name": {
          "type": "value",
          "value": "genitourinaryCheck"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "Checkbox",
      "parent": 62,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.systemicEvaluation?.endrocrineCheck"
        },
        "disabled": {
          "type": "code",
          "value": "props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Checkbox-74"
        },
        "label": {
          "type": "value",
          "value": "ระบบต่อมไร้ท่อ และระบบเผาผลาญ",
          "valueEN": "Endocrine & metabolic"
        },
        "name": {
          "type": "value",
          "value": "endrocrineCheck"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "Checkbox",
      "parent": 64,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.systemicEvaluation?.skinCheck"
        },
        "disabled": {
          "type": "code",
          "value": "props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Checkbox-75"
        },
        "label": {
          "type": "value",
          "value": "ผิวหนัง / เต้านม",
          "valueEN": "Skin /  Breast"
        },
        "name": {
          "type": "value",
          "value": "skinCheck"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 76,
      "name": "Checkbox",
      "parent": 66,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.systemicEvaluation?.immunologyCheck"
        },
        "disabled": {
          "type": "code",
          "value": "props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Checkbox-76"
        },
        "label": {
          "type": "value",
          "value": "ระบบภูมิคุ้มกัน / ระบบเลือด",
          "valueEN": "Immunology / Hematology"
        },
        "name": {
          "type": "value",
          "value": "immunologyCheck"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Dropdown",
      "parent": 63,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.endrocrineCheck || props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Dropdown-84"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "endrocrineDetail"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.handleAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.endrocrineOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.endrocrineDetail"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "Dropdown",
      "parent": 51,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.respiratoryCheck || props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Dropdown-85"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "respiratoryDetail"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.handleAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.respiratoryOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.respiratoryDetail"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-86"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-87"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ alignItems: \"flex-start\" }"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "FormField",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-88"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-89"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "FormField",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-90"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-91"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", width: \"100%\" }"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"80%\" }"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "value",
          "value": "การตรวจเพิ่มเติมที่เกี่ยวข้อง :",
          "valueEN": "Other Investigations :"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 91,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-95"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อมูลห้องปฏิบัติการ:",
          "valueEN": "Lab Data:"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-96"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "code",
          "value": "props.logoLab"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "FormField",
      "parent": 98,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-98"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "FormField",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-99"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "FormField",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-101"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "Dropdown",
      "parent": 93,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Dropdown-102"
        },
        "name": {
          "type": "value",
          "value": "labDataType"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.systemicEvaluationOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.labDataType"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 99,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-103"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\"  }"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "div",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-105"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", width: \"100%\" }"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่รายงานผล :",
          "valueEN": "Result date:"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-106"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" , width: \"30%\"}"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-107"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"60%\" }"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 108,
      "name": "DateTextBox",
      "parent": 107,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-DateTextBox-108"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeLabDate"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.labDataDate"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-109"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ alignItems: \"flex-start\" }"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormGroup-110"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ alignItems: \"flex-start\" }"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-111"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-112"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-113"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-114"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "FormField",
      "parent": 109,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-115"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "FormField",
      "parent": 109,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-116"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "FormField",
      "parent": 109,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-117"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "FormField",
      "parent": 110,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-118"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "FormField",
      "parent": 110,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-119"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "FormField",
      "parent": 110,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-120"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-122"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "div",
      "parent": 114,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-123"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-124"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "div",
      "parent": 116,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-125"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "div",
      "parent": 120,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-126"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-127"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 128,
      "name": "Checkbox",
      "parent": 95,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.systemicEvaluation?.xRayCheck"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Checkbox-128"
        },
        "label": {
          "type": "value",
          "value": "Chest X-ray",
          "valueEN": "Chest X-ray"
        },
        "name": {
          "type": "value",
          "value": "xRayCheck"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 129,
      "name": "Checkbox",
      "parent": 122,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.systemicEvaluation?.imagingCheck"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Checkbox-129"
        },
        "label": {
          "type": "value",
          "value": "Imaging",
          "valueEN": "Imaging"
        },
        "name": {
          "type": "value",
          "value": "imagingCheck"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 130,
      "name": "Checkbox",
      "parent": 125,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.systemicEvaluation?.ekgCheck"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Checkbox-130"
        },
        "label": {
          "type": "value",
          "value": "EKG",
          "valueEN": "EKG"
        },
        "name": {
          "type": "value",
          "value": "ekgCheck"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 131,
      "name": "Checkbox",
      "parent": 127,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.systemicEvaluation?.otherCheck"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Checkbox-131"
        },
        "label": {
          "type": "value",
          "value": "อื่นๆ",
          "valueEN": "Other"
        },
        "name": {
          "type": "value",
          "value": "otherCheck"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 111,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-132"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "FormField",
      "parent": 109,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-137"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "div",
      "parent": 137,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-138"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", width: \"100%\" }"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 138,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่รายงานผล :",
          "valueEN": "Result date:"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-139"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" , width: \"30%\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 140,
      "name": "div",
      "parent": 138,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-140"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"60%\" }"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 141,
      "name": "DateTextBox",
      "parent": 140,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.ekgCheck"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeEKGDate"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.ekgDate"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "TextArea",
      "parent": 126,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.otherCheck"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-TextArea-142"
        },
        "name": {
          "type": "value",
          "value": "otherDetail"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "rows": {
          "type": "code",
          "value": "2"
        },
        "style": {
          "type": "code",
          "value": "{ resize: \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.otherDetail"
        }
      },
      "seq": 142,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "TextArea",
      "parent": 124,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.ekgCheck"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-TextArea-143"
        },
        "name": {
          "type": "value",
          "value": "ekgDetail"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "rows": {
          "type": "code",
          "value": "2"
        },
        "style": {
          "type": "code",
          "value": "{ resize: \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.ekgDetail"
        }
      },
      "seq": 143,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "TextArea",
      "parent": 123,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.imagingCheck"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-TextArea-144"
        },
        "name": {
          "type": "value",
          "value": "imagingDetail"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "rows": {
          "type": "code",
          "value": "2"
        },
        "style": {
          "type": "code",
          "value": "{ resize: \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.imagingDetail"
        }
      },
      "seq": 144,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "TextArea",
      "parent": 132,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.xRayCheck"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-TextArea-145"
        },
        "name": {
          "type": "value",
          "value": "xRayDetail"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "rows": {
          "type": "code",
          "value": "2"
        },
        "style": {
          "type": "code",
          "value": "{ resize: \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.xRayDetail"
        }
      },
      "seq": 145,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 146,
      "name": "TextArea",
      "parent": 103,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-TextArea-146"
        },
        "name": {
          "type": "value",
          "value": "labDataDetail"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "rows": {
          "type": "code",
          "value": "2"
        },
        "style": {
          "type": "code",
          "value": "{ resize: \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.labDataDetail"
        }
      },
      "seq": 146,
      "void": true
    },
    {
      "from": null,
      "id": 156,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-156"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 157,
      "name": "div",
      "parent": 156,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้บันทึกล่าสุด:",
          "valueEN": "Latest recorder:"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-157"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",height:\"40px\", fontWeight:\"bold\",alignItems:\"center\", ...(props.systemicEvaluation?.status !== \"DRAFT\" && { display: \"none\" })}"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": null,
      "id": 158,
      "name": "div",
      "parent": 156,
      "props": {
        "children": {
          "type": "code",
          "value": "props.systemicEvaluation?.edit_user_name || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-158"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"10%\", margin: \"0px 10px\", ...(props.systemicEvaluation?.status !== \"DRAFT\" && { display: \"none\" }) }"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": null,
      "id": 159,
      "name": "div",
      "parent": 156,
      "props": {
        "children": {
          "type": "code",
          "value": "props.systemicEvaluation?.edited || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-159"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"10%\", margin: \"0px 10px\", ...(props.systemicEvaluation?.status !== \"DRAFT\" && { display: \"none\" }) }"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": null,
      "id": 160,
      "name": "div",
      "parent": 156,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-160"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 162,
      "name": "Dropdown",
      "parent": 53,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.cardiovascularCheck || props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Dropdown-162"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "cardiovascularDetail"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.handleAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.cardiovascularOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.cardiovascularDetail"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 163,
      "name": "Dropdown",
      "parent": 55,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.neurologicCheck || props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Dropdown-163"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "neurologicDetail"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.handleAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.neurologicOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.neurologicDetail"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "Dropdown",
      "parent": 57,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.eentCheck || props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Dropdown-164"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "eentDetail"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.handleAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.eentOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.eentDetail"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "Dropdown",
      "parent": 59,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.giCheck || props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Dropdown-165"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "giDetail"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.handleAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.giOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.giDetail"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "Dropdown",
      "parent": 61,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.genitourinaryCheck || props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Dropdown-166"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "genitourinaryDetail"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.handleAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.genitourinaryOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.genitourinaryDetail"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "Dropdown",
      "parent": 65,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.skinCheck || props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Dropdown-167"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "skinDetail"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.handleAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.skinOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.skinDetail"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 168,
      "name": "Dropdown",
      "parent": 67,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.immunologyCheck || props.systemicEvaluation?.systemicEvaluationType !== \"Abnormal\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-Dropdown-168"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "immunologyDetail"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.handleAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.immunologyOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.immunologyDetail"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 169,
      "name": "FormField",
      "parent": 110,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-169"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 170,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-170"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 171,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-FormField-171"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "div",
      "parent": 170,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-172"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", width: \"100%\" }"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "div",
      "parent": 169,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-173"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", width: \"100%\" }"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "div",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-174"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", width: \"100%\" }"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "div",
      "parent": 174,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่รายงานผล :",
          "valueEN": "Result date:"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-175"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" , width: \"30%\"}"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "div",
      "parent": 174,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-176"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"60%\" }"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่รายงานผล :",
          "valueEN": "Result date:"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-177"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" , width: \"30%\"}"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "div",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-178"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"60%\" }"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 179,
      "name": "div",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่รายงานผล :",
          "valueEN": "Result date:"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-179"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" , width: \"30%\"}"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": null,
      "id": 180,
      "name": "div",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-div-180"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"60%\" }"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 181,
      "name": "DateTextBox",
      "parent": 180,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.otherCheck"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-DateTextBox-181"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeOtherDate"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.otherDate"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 182,
      "name": "DateTextBox",
      "parent": 178,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.imagingCheck"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-DateTextBox-182"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeImagingDate"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.imagingDate"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 183,
      "name": "DateTextBox",
      "parent": 176,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.systemicEvaluation?.xRayCheck"
        },
        "id": {
          "type": "value",
          "value": "CardSystemicEvaluationUX-DateTextBox-183"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeXRayDate"
        },
        "value": {
          "type": "code",
          "value": "props.systemicEvaluation?.xRayDate"
        }
      },
      "seq": 183,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardSystemicEvaluationUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
